export const imageLinks = {
  polarH10:
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/setup-images/polar-h10.png',
  coospoH808S:
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/setup-images/coospo-h808s.png',
  polarVeritySense:
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/setup-images/polar-verity-sense.webp',
  appleWatch:
    'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/setup-images/apple-watch-pulsoid.webp',
};
